import type { TourStep } from './types'

export const TOUR_STEPS: TourStep[] = [
  {
    id: 'nav-meetings',
    targetId: 'tour-nav-meetings',
    title: 'tour.meetingsTitle',
    description: 'tour.meetingsDescription',
    placement: 'right',
    group: 'tour.sidebarNavigation',
  },
  {
    id: 'nav-chat',
    targetId: 'tour-nav-chat',
    title: 'tour.chatsTitle',
    description: 'tour.chatsDescription',
    placement: 'right',
    group: 'tour.sidebarNavigation',
  },
  {
    id: 'nav-webinar',
    targetId: 'tour-nav-webinar',
    title: 'tour.webinarsTitle',
    description: 'tour.webinarsDescription',
    placement: 'right',
    group: 'tour.sidebarNavigation',
  },
  {
    id: 'nav-calendar',
    targetId: 'tour-nav-calendar',
    title: 'tour.calendarTitle',
    description: 'tour.calendarDescription',
    placement: 'right',
    group: 'tour.sidebarNavigation',
  },
  {
    id: 'nav-rooms',
    targetId: 'tour-nav-rooms',
    title: 'tour.roomsTitle',
    description: 'tour.roomsDescription',
    placement: 'right',
    group: 'tour.sidebarNavigation',
  },
  {
    id: 'nav-settings',
    targetId: 'tour-nav-settings',
    title: 'tour.settingsTitle',
    description: 'tour.settingsDescription',
    placement: 'right',
    group: 'tour.sidebarNavigation',
  },
  {
    id: 'action-instant',
    targetId: 'tour-action-instant',
    title: 'tour.instantMeetingTitle',
    description: 'tour.instantMeetingDescription',
    placement: 'bottom',
    group: 'tour.quickActions',
  },
  {
    id: 'action-join',
    targetId: 'tour-action-join',
    title: 'tour.joinMeetingTitle',
    description: 'tour.joinMeetingDescription',
    placement: 'bottom',
    group: 'tour.quickActions',
  },
  {
    id: 'action-schedule',
    targetId: 'tour-action-schedule',
    title: 'tour.scheduleTitle',
    description: 'tour.scheduleDescription',
    placement: 'bottom',
    group: 'tour.quickActions',
  },
  {
    id: 'action-share',
    targetId: 'tour-action-share',
    title: 'tour.screenShareTitle',
    description: 'tour.screenShareDescription',
    placement: 'bottom',
    group: 'tour.quickActions',
  },
  {
    id: 'header-notification',
    targetId: 'tour-header-notification',
    title: 'tour.notificationsTitle',
    description: 'tour.notificationsDescription',
    placement: 'bottom',
    group: 'tour.header',
  },
  {
    id: 'header-avatar',
    targetId: 'tour-header-avatar',
    title: 'tour.yourProfileTitle',
    description: 'tour.yourProfileDescription',
    placement: 'bottom',
    group: 'tour.header',
  },
]
